<!--
* @Name：收货单状态变更申请审批明细页面
* @Author: 陈名刚
* @Date: 2024-05-13
-->
<template>
  <div>
    <hi-card v-for="(item, index) in purReceivingChangeItemList" :key="item.purchaseApplyItemId" :row-index="index + 1">
      <van-row>
        <span>公司：</span>
        <span>{{ item.companyName }}</span>
      </van-row>
      <van-row>
        <span>单据类型：</span>
        <span>{{ item.purOrderType | dictFilter($store.getters.dicts.pur_order_type) }}</span>
      </van-row>
      <!--<van-row>-->
      <!--<span>供应商编号：</span>-->
      <!--        <span>{{ item.suppCode }}</span>-->
      <!--      </van-row>-->
      <van-row>
        <span>供应商：</span>
        <span>{{ item.suppName }}</span>
      </van-row>
      <van-row>
        <span>收货单：</span>
        <span>{{ item.asnNo }}</span>
      </van-row>
      <!--      <van-row>-->
      <!--        <span>收货单行号：</span>-->
      <!--        <span>{{ item.asnItemNo }}</span>-->
      <!--      </van-row>-->
      <!--      <van-row>-->
      <!--        <span>采购组：</span>-->
      <!--        <span>{{ item.purgrpName }}</span>-->
      <!--      </van-row>-->
      <van-row>
        <span>料号：</span>
        <span>{{ item.materialCode }}</span>
      </van-row>
      <van-row>
        <span>品名：</span>
        <span>{{ item.materialDescribe }}</span>
      </van-row>
      <van-row>
        <span>可结算数量：</span>
        <span>{{ item.isStatementQty }}</span>
      </van-row>
      <van-row>
        <span>含税单价：</span>
        <span>{{ item.unitPrice }}</span>
      </van-row>
      <!--      <van-row>-->
      <!--        <span>未税金额：</span>-->
      <!--        <span>{{ item.amountNoTax }}</span>-->
      <!--      </van-row>-->
      <van-row>
        <span>税额：</span>
        <span>{{ item.taxAmount }}</span>
      </van-row>
      <van-row>
        <span>价税合计：</span>
        <span>{{ item.tatalAmountTax }}</span>
      </van-row>
    </hi-card>
  </div>
</template>

<script>
export default {
  name: 'Details',
  data() {
    return {}
  },
  props: {
    purReceivingChangeItemList: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  computed: {},
  methods: {}
}
</script>
